import Vue from "vue";
import App from "./App.vue";
import Buefy from "buefy";
import "./assets/scss/main.scss";
import "./vee-validate";
import i18n from "./i18n";
import router from "./router";

Vue.use(Buefy);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");
